import { StyleSheet } from 'aphrodite';
import { navigation, white } from '../../../../../web/styles/colors';
import { CssSelectors, Layouts } from '../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	approvalReminderModal: {
		...CssSelectors.allDescendants(
			{
				maxWidth: 420,
			},
			'.modal-overlay-content'
		),
	},
	approvalsHeader: {
		...Layouts.horizontalStack(40),
		justifyContent: 'flex-end',
		marginTop: 20,
	},
	approvalsHeaderCta: {
		...Layouts.horizontalStack(10),
		color: '#858585',
		fontSize: 14,
		...CssSelectors.allChildren(
			{
				height: 15,
				width: 15,
			},
			'.svg-icon'
		),
	},
	automationRow: {
		':hover': {
			cursor: 'default',
		},
		cursor: 'default',
	},
	container: {
		minHeight: 300,
	},
	groupEmailTableRow: {
		cursor: 'auto',
	},
	header: {
		borderBottom: '1px solid #D3DBDE77',
		color: navigation,
		display: 'flex',
		fontSize: 12,
		justifyContent: 'flex-start',
		padding: '40px 0 20px',
		background: white,
	},
	headerItem: {
		minWidth: 300,
		width: '33%',
	},
	loader: {
		marginTop: 30,
		minHeight: 300,
	},
	noneFound: {
		color: navigation,
		letterSpacing: 1.1,
		marginTop: 30,
		textAlign: 'center',
		textTransform: 'uppercase',
	},
	spinnerContainer: {
		display: 'flex',
		justifyContent: 'center',
		margin: 30,
	},
	toolbar: {},
});
